import React from "react";
import type { ArtistDTO, StageDTO } from "../lib/api";

export function Stages({
  stages,
  artists,
  onPickStage,
}: {
  stages: StageDTO[];
  artists: ArtistDTO[];
  onPickStage: (slug: string) => void;
}) {
  const counts = new Map<string, number>();
  for (const a of artists) {
    const seen = new Set<string>();
    for (const s of a.sets) {
      if (seen.has(s.stage.slug)) continue;
      seen.add(s.stage.slug);
      counts.set(s.stage.slug, (counts.get(s.stage.slug) ?? 0) + 1);
    }
  }

  return (
    <div data-testid="view-stages">
      <div className="section-head">
        <div>
          <span className="super">9 STAGES · 3 NIGHTS</span>
          <h2>Stages</h2>
        </div>
      </div>
      <div className="stages-grid">
        {stages.map(s => (
          <button
            key={s.slug}
            className="stage-card"
            data-testid="stage-card"
            data-slug={s.slug}
            onClick={() => onPickStage(s.slug)}
            style={{ ["--stage-color" as never]: s.color ?? "#ff6a13" }}
          >
            <div>
              <div className="stage-title" style={{ color: s.color ?? "#fff" }}>{s.name}</div>
              <div className="stage-vibe">{s.vibe}</div>
            </div>
            <div className="stage-count" style={{ textAlign: "right" }}>
              <div className="count-num">{counts.get(s.slug) ?? 0}</div>
              acts
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
